import { MessageType } from '../../utils/message';
let counter = 0;
const resolvers = new Map();
const rejectors = new Map();
export async function bgFetch(request) {
    return new Promise((resolve, reject) => {
        const id = ++counter;
        resolvers.set(id, resolve);
        rejectors.set(id, reject);
        chrome.runtime.sendMessage({ type: MessageType.CS_FETCH, data: request, id });
    });
}
chrome.runtime.onMessage.addListener(({ type, data, error, id }) => {
    if (type === MessageType.BG_FETCH_RESPONSE) {
        const resolve = resolvers.get(id);
        const reject = rejectors.get(id);
        resolvers.delete(id);
        rejectors.delete(id);
        if (error) {
            reject && reject(error);
        }
        else {
            resolve && resolve(data);
        }
    }
});
